import React, { Component } from 'react';
import { getToken } from './utils/utils';

export default ChildComponent => {
  class ComposedComponent extends Component {
    componentDidMount() {
      this.shouldNavigateAway();
    }

    componentDidUpdate(prevProps, prevState) {
      this.shouldNavigateAway();
    }

    shouldNavigateAway() {
      const { token } = getToken('zenon_token') || '';
      if (!token) {
        this.props.history.push('/');
      }
    }

    render() {
      return <ChildComponent {...this.props} />
    }
  }

  return ComposedComponent;
};